import apiProvider from './provider';
import {
  INVITE_USER,
  FETCH_ACCOUNT_DETAILS,
  FETCH_ALL_USERS_OF_CURRENT_ORGANISATION,
  FETCH_ALL_USERS_BY_ORGANISATION,
  CHANGE_USER_STATUS,
  RESEND_USER_INVITE, DELETE_INVITE, USER_NOTIFICATION_PREFERENCES, DOWNLOAD_USERS, UPDATE_FINANCING_CTA_STATUS,
  SET_HOME_PAGE,
} from './routes';
import { getAuthenticationHeaders, getErrorMessage, getOrgPrettyName } from './utils';
import { API_BASE_URL } from 'src/globals';
import { ApiResponseWrapper, GET, PATCH } from './apiHandler';
import { APIResponseType } from 'src/Library/Types';
import { NotificationPreferences, NotificationActionType } from 'src/dto/response/getNotificationPreferences';
import { AxiosResponse } from 'axios';

export const inviteUser = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + INVITE_USER, body,
      {
        headers: Object.assign({ 'organisation-pretty-name': getOrgPrettyName() },
          getAuthenticationHeaders(),
        ),
      },
    );
    return {
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const setHomePage = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + SET_HOME_PAGE, 
      body,
      {
        headers: {
          'organisation-pretty-name': getOrgPrettyName(),
          ...getAuthenticationHeaders(),
        },
      },
    );
    
    return {
      isSuccess: true,
      data: response.data, // Include response data if needed
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchAllUsersOfCurrentOrg = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      API_BASE_URL + FETCH_ALL_USERS_OF_CURRENT_ORGANISATION,
      {
        headers: Object.assign({ 'organisation-pretty-name': getOrgPrettyName() },
          getAuthenticationHeaders(),
        ),
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchAllUsersOfOrg = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${FETCH_ALL_USERS_BY_ORGANISATION}`,
      body,
      {
        headers: getAuthenticationHeaders()
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const changeStatus = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + CHANGE_USER_STATUS,
      body,
      {
        headers: Object.assign({ 'organisation-pretty-name': getOrgPrettyName() },
          getAuthenticationHeaders(),
        ),
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const resendInvite = async (email) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + RESEND_USER_INVITE,
      { email },
      {
        headers: Object.assign({ 'organisation-pretty-name': getOrgPrettyName() },
          getAuthenticationHeaders(),
        ),
      },
    );
    return {
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const deleteInvite = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + DELETE_INVITE,
      body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchNotificationPreferences = async (params: { bucketCodes: string[] }): Promise<
  APIResponseType<NotificationPreferences>> => {
  return GET(`${API_BASE_URL}${USER_NOTIFICATION_PREFERENCES}`, params);
}

export const changeNotificationPreferences = (body: NotificationActionType[]) => {
  return PATCH(`${API_BASE_URL}${USER_NOTIFICATION_PREFERENCES}`, body);
}

export const downloadUsers = async (body: any): Promise<
  APIResponseType<any>
> => {
  return GET(`${API_BASE_URL}${DOWNLOAD_USERS}`, body, 'blob');
}

export const updateFinancingCtaStatus = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + UPDATE_FINANCING_CTA_STATUS,
      body,
      {
        headers: Object.assign({ 'organisation-pretty-name': getOrgPrettyName() },
          getAuthenticationHeaders(),
        ),
      },
    );
    return {
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};